module.exports = __webpack_public_path__ + "static/media/s-home_formats_seminar.435f4b31.jpg";